import React from 'react';
import Link from 'apollo-react/components/Link';
import useFileDownload from '../../../hooks/api/files/useFileDownload';
import { truncateFileName } from '../../utils/stringUtils';
import styles from './FileLink.module.css';

/**
 * FileLink - Reusable component for rendering a clickable file link
 * Handles file preview/download with authenticated API calls
 *
 * @param {Object} props
 * @param {Object} props.file - File object { id, name, mime_type }
 * @param {number} props.maxNameLength - Maximum file name length before truncation (default 30)
 */
const FileLink = ({ file, maxNameLength = 30, includeDeleted = false }) => {
  const { downloadFileForEndUserFilledForm, downloading } = useFileDownload();

  const handleClick = () => {
    downloadFileForEndUserFilledForm(file, { includeDeleted });
  };

  const displayName = truncateFileName(file.name, maxNameLength);

  return (
    <Link
      onClick={handleClick}
      className={downloading ? styles.downloading : styles.link}
      title={file.name}
    >
      {displayName}
    </Link>
  );
};

export default FileLink;
